import React from 'react';
import './TabNavigation.scss';

const TabNavigation = ({ activeTab, onTabChange }) => {
	const tabs = [
		{ id: 'overview', label: 'Overview' },
		{ id: 'experience', label: 'Experience' },
		{ id: 'skills', label: 'Technical Skills' },
	];

	return (
		<nav className="tab-navigation">
			{tabs.map((tab) => (
				<button
					key={tab.id}
					className={`tab-navigation__button ${activeTab === tab.id ? 'tab-navigation__button--active' : ''}`}
					onClick={() => onTabChange(tab.id)}
				>
					{tab.label}
				</button>
			))}
		</nav>
	);
};

export default TabNavigation;
